module.exports = __webpack_public_path__ + "static/media/megumin.e79ad429.png";